var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEx3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3335 27.9167C37.6431 27.9167 37.0835 27.3571 37.0835 26.6667C37.0835 25.9764 37.6431 25.4167 38.3335 25.4167H43.3335C44.0239 25.4167 44.5835 25.9764 44.5835 26.6667V31.6667C44.5835 32.3571 44.0239 32.9167 43.3335 32.9167C42.6431 32.9167 42.0835 32.3571 42.0835 31.6667V29.6845L38.384 33.3839C37.8959 33.8721 37.1044 33.8721 36.6163 33.3839C36.1281 32.8958 36.1281 32.1043 36.6163 31.6162L40.3157 27.9167H38.3335Z",
    fill: "url(#paint0_linear_255_777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.384 36.6162C33.8722 37.1043 33.8722 37.8958 33.384 38.3839L29.6846 42.0834H31.6668C32.3572 42.0834 32.9168 42.643 32.9168 43.3334C32.9168 44.0237 32.3572 44.5834 31.6668 44.5834H26.6668C25.9765 44.5834 25.4168 44.0237 25.4168 43.3334V38.3334C25.4168 37.643 25.9765 37.0834 26.6668 37.0834C27.3572 37.0834 27.9168 37.643 27.9168 38.3334V40.3156L31.6163 36.6162C32.1044 36.128 32.8959 36.128 33.384 36.6162Z",
    fill: "url(#paint1_linear_255_777)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6668 27.9167C32.3572 27.9167 32.9168 27.3571 32.9168 26.6667C32.9168 25.9764 32.3572 25.4167 31.6668 25.4167H26.6668C25.9765 25.4167 25.4168 25.9764 25.4168 26.6667V31.6667C25.4168 32.3571 25.9765 32.9167 26.6668 32.9167C27.3572 32.9167 27.9168 32.3571 27.9168 31.6667V29.6845L31.6163 33.3839C32.1044 33.8721 32.8959 33.8721 33.384 33.3839C33.8722 32.8958 33.8722 32.1043 33.384 31.6162L29.6846 27.9167H31.6668Z",
    fill: "url(#paint2_linear_255_777)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6163 36.6162C36.1281 37.1043 36.1281 37.8958 36.6163 38.3839L40.3157 42.0834H38.3335C37.6431 42.0834 37.0835 42.643 37.0835 43.3334C37.0835 44.0237 37.6431 44.5834 38.3335 44.5834H43.3335C44.0239 44.5834 44.5835 44.0237 44.5835 43.3334V38.3334C44.5835 37.643 44.0239 37.0834 43.3335 37.0834C42.6431 37.0834 42.0835 37.643 42.0835 38.3334V40.3156L38.384 36.6162C37.8959 36.128 37.1044 36.128 36.6163 36.6162Z",
    fill: "url(#paint3_linear_255_777)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9045 17.0834C31.0572 17.0834 28.0421 17.0833 25.6897 17.3996C23.2818 17.7234 21.3817 18.3989 19.8904 19.8903C18.399 21.3816 17.7235 23.2817 17.3997 25.6896C17.0835 28.042 17.0835 31.0571 17.0835 34.9044V35.0957C17.0835 38.943 17.0835 41.9581 17.3997 44.3105C17.7235 46.7184 18.399 48.6185 19.8904 50.1098C21.3817 51.6012 23.2818 52.2767 25.6897 52.6005C28.0422 52.9167 31.0572 52.9167 34.9045 52.9167H35.0958C38.9431 52.9167 41.9582 52.9167 44.3107 52.6005C46.7185 52.2767 48.6186 51.6012 50.1099 50.1098C51.6013 48.6185 52.2769 46.7184 52.6006 44.3105C52.9169 41.9581 52.9169 38.943 52.9168 35.0957V34.9044C52.9169 31.0571 52.9169 28.042 52.6006 25.6896C52.2769 23.2817 51.6013 21.3816 50.1099 19.8903C48.6186 18.3989 46.7185 17.7234 44.3107 17.3996C41.9582 17.0833 38.9431 17.0834 35.0958 17.0834H34.9045ZM21.6582 21.658C22.6076 20.7086 23.8921 20.1638 26.0228 19.8773C28.1894 19.586 31.0365 19.5834 35.0002 19.5834C38.9639 19.5834 41.8109 19.586 43.9775 19.8773C46.1082 20.1638 47.3927 20.7086 48.3422 21.658C49.2916 22.6075 49.8364 23.892 50.1229 26.0227C50.4142 28.1893 50.4168 31.0363 50.4168 35C50.4168 38.9637 50.4142 41.8108 50.1229 43.9774C49.8364 46.1081 49.2916 47.3926 48.3422 48.342C47.3927 49.2915 46.1082 49.8363 43.9775 50.1228C41.8109 50.4141 38.9639 50.4167 35.0002 50.4167C31.0365 50.4167 28.1894 50.4141 26.0228 50.1228C23.8921 49.8363 22.6076 49.2915 21.6582 48.342C20.7087 47.3926 20.1639 46.1081 19.8774 43.9774C19.5862 41.8108 19.5835 38.9637 19.5835 35C19.5835 31.0363 19.5862 28.1893 19.8774 26.0227C20.1639 23.892 20.7087 22.6075 21.6582 21.658Z",
    fill: "url(#paint4_linear_255_777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_777",
    x1: 35.0002,
    y1: 17.0834,
    x2: 35.0002,
    y2: 52.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_777",
    x1: 35.0002,
    y1: 17.0834,
    x2: 35.0002,
    y2: 52.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_777",
    x1: 35.0002,
    y1: 17.0834,
    x2: 35.0002,
    y2: 52.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_255_777",
    x1: 35.0002,
    y1: 17.0834,
    x2: 35.0002,
    y2: 52.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_255_777",
    x1: 35.0002,
    y1: 17.0834,
    x2: 35.0002,
    y2: 52.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx3);
export default __webpack_public_path__ + "static/media/ex3.723a259a426e1eeb223ac9b4b4691f96.svg";
export { ForwardRef as ReactComponent };